export default "__VITE_ASSET__B955gBon__"